<template>
  <div class="container">
    <div class="toolbar shadow-sm">
      <img src="@/assets/icons/MapsIcon.png" />
      <span class="title">{{ name }}</span>
      <div>
        <button :class="mapButtonClass" v-on:click="handleMapButtonClicked()">
          {{ $t('admin.map.main_toolbar.map_button') }}
        </button>
      </div>
      <div>
        <button :class="statusButtonClass" v-on:click="handleStatusButtonClicked()">
          {{ $t('admin.map.main_toolbar.status_button') }}
        </button>
      </div>
      <div>
        <button
          :class="openingMessagesButtonClass"
          v-on:click="handleOpeningMessagesButtonClicked()"
        >
          {{ $t('admin.map.main_toolbar.opening_messages_button') }}
        </button>
      </div>
      <div>
        <button
          :class="pushNotificationsButtonClass"
          v-on:click="handlePushNotificationsButtonClicked()"
        >
          {{ $t('admin.map.main_toolbar.push_notifications_button') }}
        </button>
      </div>
      <div>
        <button :class="configurationButtonClass" v-on:click="handleConfigurationButtonClicked()">
          {{ $t('admin.map.main_toolbar.configuration_button') }}
        </button>
      </div>
      <div>
        <button :class="webIntegrationButtonClass" v-on:click="handleWebIntegrationButtonClicked()">
          {{ $t('admin.map.main_toolbar.web_integration_button') }}
        </button>
      </div>
      <div>
        <button :class="exportMapDataButtonClass" v-on:click="handleExportMapDataButtonClicked()">
          {{ $t('admin.map.main_toolbar.export_map_data_button') }}
        </button>
      </div>
      <div>
        <button :class="exportMapDataButtonClass" v-on:click="handleExportMapMediaButtonClicked()">
          {{ $t('admin.map.main_toolbar.export_map_media_button') }}
        </button>
      </div>
      <div class="loading-icon" v-if="loading">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
    <div v-if="this.publisher" class="content-container">
      <MapEditor
        v-if="selectedToolbarButtonId == 'map'"
        v-bind:publisherId="this.publisher.id"
        v-bind:mapId="this.mapId"
        v-bind:objectId="this.objectId"
      />
      <StatusEditor
        v-if="selectedToolbarButtonId == 'status'"
        v-bind:publisherId="this.publisher.id"
        v-bind:mapId="this.mapId"
      />
      <OpeningMessagesEditor
        v-if="selectedToolbarButtonId == 'openingMessages'"
        v-bind:publisherId="this.publisher.id"
        v-bind:mapId="this.mapId"
      />
      <PushNotificationsEditor
        v-if="selectedToolbarButtonId == 'pushNotifications'"
        v-bind:publisherId="this.publisher.id"
        v-bind:mapId="this.mapId"
      />
      <ConfigurationEditor
        v-if="selectedToolbarButtonId == 'configuration'"
        v-bind:publisherId="this.publisher.id"
        v-bind:mapId="this.mapId"
      />
      <WebIntegrationEditor
        v-if="selectedToolbarButtonId == 'webIntegration'"
        v-bind:publisherId="this.publisher.id"
        v-bind:mapId="this.mapId"
      />
    </div>
  </div>
</template>

<script>
import MapService from '@/service/MapService.js';
import LangUtils from '@/utils/LangUtils.js';
import MapEditor from './editor/MapEditor';
import StatusEditor from './editor/StatusEditor';
import OpeningMessagesEditor from './editor/OpeningMessagesEditor';
import PushNotificationsEditor from './editor/PushNotificationsEditor';
import ConfigurationEditor from './editor/ConfigurationEditor';
import WebIntegrationEditor from './editor/WebIntegrationEditor';

const mapService = new MapService();

export default {
  components: {
    MapEditor,
    StatusEditor,
    OpeningMessagesEditor,
    PushNotificationsEditor,
    ConfigurationEditor,
    WebIntegrationEditor,
  },

  computed: {
    name() {
      return this.map != null
        ? LangUtils.valueForLanguage(this.map.getName(), this.$i18n.locale)
        : '';
    },

    mapButtonClass() {
      return (
        'btn btn-outline-primary btn-sm' + (this.selectedToolbarButtonId == 'map' ? ' active' : '')
      );
    },

    statusButtonClass() {
      return (
        'btn btn-outline-primary btn-sm' +
        (this.selectedToolbarButtonId == 'status' ? ' active' : '')
      );
    },

    openingMessagesButtonClass() {
      return (
        'btn btn-outline-primary btn-sm' +
        (this.selectedToolbarButtonId == 'openingMessages' ? ' active' : '')
      );
    },

    pushNotificationsButtonClass() {
      return (
        'btn btn-outline-primary btn-sm' +
        (this.selectedToolbarButtonId == 'pushNotifications' ? ' active' : '')
      );
    },

    configurationButtonClass() {
      return (
        'btn btn-outline-primary btn-sm' +
        (this.selectedToolbarButtonId == 'configuration' ? ' active' : '')
      );
    },

    webIntegrationButtonClass() {
      return (
        'btn btn-outline-primary btn-sm' +
        (this.selectedToolbarButtonId == 'webIntegration' ? ' active' : '')
      );
    },

    exportMapDataButtonClass() {
      return 'btn btn-link btn-sm';
    },
  },

  data() {
    return {
      loading: false,
      publisher: null,
      map: null,
      mapSpec: null,
      mapId: this.$route.params.mapId,
      objectId: this.$route.params.objectId,
      selectedToolbarButtonId: 'map',
    };
  },
  watch: {
    '$store.state.currentPublisher': function () {
      this.publisher = this.$store.state.currentPublisher;
      this.loadMap();
    },
  },
  methods: {
    loadMap() {
      if (this.publisher && this.mapId) {
        mapService
          .loadMapForPublisher(this.publisher.getId(), this.mapId)
          .then((map) => {
            this.map = map;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    handleMapButtonClicked() {
      this.selectedToolbarButtonId = 'map';
    },

    handleStatusButtonClicked() {
      this.selectedToolbarButtonId = 'status';
    },

    handleOpeningMessagesButtonClicked() {
      this.selectedToolbarButtonId = 'openingMessages';
    },

    handlePushNotificationsButtonClicked() {
      this.selectedToolbarButtonId = 'pushNotifications';
    },

    handleConfigurationButtonClicked() {
      this.selectedToolbarButtonId = 'configuration';
    },

    handleWebIntegrationButtonClicked() {
      this.selectedToolbarButtonId = 'webIntegration';
    },

    handleExportMapDataButtonClicked() {
      this.loading = true;
      mapService
        .exportMapData(this.publisher.getId(), this.mapId)
        .then((exportedData) => {
          const blob = new Blob([exportedData], { type: 'text/csv' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = this.publisher.getId() + '_' + this.mapId + '_export.csv';
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleExportMapMediaButtonClicked() {
      this.loading = true;
      mapService
        .exportMapMedia(this.publisher.getId(), this.mapId)
        .then((exportedData) => {
          const blob = new Blob([exportedData], { type: 'application/x-zip' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = this.publisher.getId() + '_' + this.mapId + '_media_export.zip';
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  mounted() {
    this.publisher = this.$store.state.currentPublisher;
    this.loadMap();
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  margin: 0px;
  margin-bottom: 16px;
  width: 100%;
  max-width: none;
}

.toolbar {
  background-color: #ffffff;
  margin-bottom: 8px;
  padding: 8px;
  padding-left: 24px;
  text-align: left;
  width: 100%;
  display: flex;
  align-items: center;
}
.toolbar .loading-icon {
  margin-left: auto;
}

.toolbar img {
  margin-right: 16px;
  width: 50px;
}

.toolbar .title {
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  margin-right: 36px;
  max-width: 250px;
}

.toolbar button {
  margin: 0px 4px;
}

.content-container {
  margin: 0 auto;
  overflow: scroll;
  text-align: left;
  width: 100%;
  height: 100%;
}
</style>
